import React from "react";
import Loader from 'react-loader-spinner'
import Modal from "../components/Modal";
import { translate } from "../utils/useful";


class OptionsListModal extends React.Component {
  state = {
  }



  render() {
    return (
      <Modal ref={el => this.modal = el} maxWidth={300}>
        <div className="w-100  text-center" style={{ backgroundColor: '#ffffffee', borderRadius: 8 }}>
          <div className="w-100" style={{ zIndex: 1, padding: '8px 15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

            <div className="text-start">
              <p className="text-small mt-1">WHAT TO DO?</p>
              {/* <p>{this.state.currentComponent?.title}</p> */}
            </div>

            <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
            </div>

          </div>
          <div className="py-2 px-2">

            {this.props.options?.map((prop, index) => {
              return (
                <button key={index} onClick={() => {prop.function();this.modal.hideModal()}} className="py-2 w-100 flexc" style={{ borderBottom: '1px solid #eee' }}>
                  <img className="mrd-3" src={prop.icon} width="24px" />
                  <div className="text-start mb-1">
                    <p className="text-normal">{prop.name}</p>
                    {prop.description && (<p className="text-smaller" style={{ lineHeight: 1, opacity: 0.3 }}>{prop.description}</p>)}
                  </div>
                </button>
              )
            })}


{/* https://www.flaticon.com/svg/static/icons/svg/747/747914.svg */}

            {/* <button className="py-2 w-100 flexc" style={{ borderBottom: '1px solid #eee' }}>
              <img className="mrd-3" src="https://www.flaticon.com/svg/static/icons/svg/747/747938.svg" width="24px" />
              <p className="text-normal">Clone</p>
            </button>

            <button onClick={() => this.removeConfirmModal.showModal()} className="py-2 w-100 flexc" style={{ borderBottom: '0px solid #eee' }}>
              <img className="mrd-3" src="https://www.flaticon.com/svg/static/icons/svg/747/747854.svg" width="24px" />
              <p className="text-normal">Remove</p>
            </button> */}

          </div>
        </div>
      </Modal>

    );
  }
}



export default OptionsListModal;
